export default {
  emptyState: (name: string): string =>
    `No top targets for ${name} available at this time.`,
  forecastButton: "Make a Forecast",
  moreTargets: "more targets",
  title: "Top Targets"
};
